import './config/dayjs';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import { configureAmplify } from './config/amplify';
//import { initializeGoogleOptimize } from './config/googleOptimize'
import { initializeGTM } from './config/googleTagManager';
import './index.css';
import './translations/i18n';
configureAmplify();
if (import.meta.env.PROD) {
    initializeGTM();
}
const rootElement = document.getElementById('root') as HTMLElement | null;
const removeInitialSpinner = () => {
    const spinner = document.getElementById('initial-global-spinner');
    if (spinner && spinner.parentNode) {
        spinner.parentNode.removeChild(spinner);
    }
};
const waitForNavigationShell = () => {
    const targetSelector = '.navigation-content';
    const removeIfReady = () => {
        if (document.querySelector(targetSelector)) {
            removeInitialSpinner();
            return true;
        }
        return false;
    };
    if (removeIfReady()) {
        return;
    }
    const observer = new MutationObserver(() => {
        if (removeIfReady()) {
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
};
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
    waitForNavigationShell();
}
else {
    waitForNavigationShell();
}

// App-shell-service worker (public/service-worker.js): suojaa auki olevan istunnon
// deployilta samaan tapaan kuin FV:n Workbox-SW. Vain tuotantobuildissa —
// paikallisessa kehityksessä SW vain häiritsisi HMR:ää.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').catch(() => {
            // rekisteröinnin epäonnistuminen ei saa vaikuttaa sovellukseen
        });
    });
}
